import {
  GET_PROFILE_DETAILS_INIT,
  GET_PROFILE_DETAILS_SUCCESS,
  GET_PROFILE_DETAILS_FAILED,
  GET_ALLOCATOR_Strategy_INIT,
  GET_ALLOCATOR_Strategy_SUCCESS,
  GET_ALLOCATOR_Strategy_FAILED,
  GET_STRATEGY_INIT,
  GET_STRATEGY_SUCCESS,
  GET_STRATEGY_FAILED,
  GET_ALL_INVESTOR_SUCCESS,
  GET_ALL_INVESTOR_FAILED,
  GET_ALL_INVESTOR_INIT,
  UPDATE_TENET_DETIALS_INIT,
  UPDATE_TENET_DETIALS_SUCCESS,
  UPDATE_TENET_DETIALS_FAILED,
  UPDATE_COVERIMAGE_INIT,
  UPDATE_COVERIMAGE_SUCCESS,
  UPDATE_COVERIMAGE_FAILED,
  UPDATE_COMPANYLOGO_INIT,
  UPDATE_COMPANYLOGO_SUCCESS,
  UPDATE_COMPANYLOGO_FAILED,
  GET_COMPANY_POST_FEED_INIT,
  GET_COMPANY_POST_FEED_SUCCESS,
  GET_COMPANY_POST_FEED_FAILED,
  GET_COMPANY_USERS_INIT,
  GET_COMPANY_USERS_SUCCESS,
  GET_COMPANY_USERS_FAILED,
  GET_FUND_SPOTLIGHTS_INIT,
  GET_FUND_SPOTLIGHTS_SUCCESS,
  GET_FUND_SPOTLIGHTS_FAILED,
  GET_ALLOCATOR_INFO_INIT,
  GET_ALLOCATOR_INFO_SUCCESS,
  GET_ALLOCATOR_INFO_FAILED,
  CREATE_ALLOCATOR_INFO_INIT,
  CREATE_ALLOCATOR_INFO_SUCCESS,
  CREATE_ALLOCATOR_INFO_FAILED,
  UPDATE_ALLOCATOR_INFO_INIT,
  UPDATE_ALLOCATOR_INFO_SUCCESS,
  UPDATE_ALLOCATOR_INFO_FAILED,
  UPDATE_FSI_INIT,
  UPDATE_FSI_SUCCESS,
  UPDATE_FSI_FAILED,
  UPDATE_NDE_INIT,
  UPDATE_NDE_SUCCESS,
  UPDATE_NDE_FAILED,
  UPDATE_IDP_INIT,
  UPDATE_IDP_SUCCESS,
  UPDATE_IDP_FAILED,
  UPDATE_IC_INIT,
  UPDATE_IC_SUCCESS,
  UPDATE_IC_FAILED,
  UPDATE_ALLOCATOR_STRATEGY_INIT,
  UPDATE_ALLOCATOR_STRATEGY_SUCCESS,
  UPDATE_ALLOCATOR_STRATEGY_FAILED,
} from "./constants";
const initialState = {
  loading: false,
  profileDetails: {},
  allocatorInfo : {},
  spotlightFunds: [],
  allocatorStratgy: [],
  stratgyList: [],
  updateAllocatorStratgy: [],
  getAllInvestors: [],
  updateTenantDetail: [],
  coverImageUrl : "",
  companyLogoUrl : "" ,
  getCompanyPostFeed : [],
  getCompanyUsers : [],
  page : 1,
  perPage : 5,
  fundSpotloading : false,
  postFeedLoading: false,
  allocatorInfoLoading : false,
};

export default function profile(state = initialState, action) {
  switch (action.type) {
    case GET_PROFILE_DETAILS_INIT:
      return { ...state, loading: true };
    case GET_PROFILE_DETAILS_SUCCESS:
      return { ...state, loading: false, profileDetails: action.payload };
    case GET_PROFILE_DETAILS_FAILED:
      return { ...state, loading: false };
    case GET_ALLOCATOR_Strategy_INIT:
      return { ...state, loading: true };
    case GET_ALLOCATOR_Strategy_SUCCESS:
      return { ...state, loading: false, allocatorStratgy: action.payload };
    case GET_ALLOCATOR_Strategy_FAILED:
      return { ...state, loading: false };
    case GET_STRATEGY_INIT:
      return { ...state, loading: true };
    case GET_STRATEGY_SUCCESS:
      return { ...state, loading: false, stratgyList: action.payload };
    case GET_STRATEGY_FAILED:
      return { ...state, loading: false };
    case GET_ALL_INVESTOR_INIT:
      return { ...state };
    case GET_ALL_INVESTOR_SUCCESS:
      return { ...state, getAllInvestors: action.payload };
    case GET_ALL_INVESTOR_FAILED:
      return { ...state };
    case UPDATE_TENET_DETIALS_INIT:
      return {
        ...state,
        loading: true,
        profileDetails: {},
      };
    case UPDATE_TENET_DETIALS_SUCCESS:
      return {
        ...state,
        loading: false,
        updateTenantDetail: action.payload,
        profileDetails: action.payload,
      };
    case UPDATE_TENET_DETIALS_FAILED:
      return { ...state, loading: false }; 
    case UPDATE_COVERIMAGE_INIT:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_COVERIMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        coverImageUrl: action.payload,
      };
    case UPDATE_COVERIMAGE_FAILED:
      return { ...state, loading: false };

    case UPDATE_COMPANYLOGO_INIT:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_COMPANYLOGO_SUCCESS:
      return {
        ...state,
        loading: false,
        companyLogoUrl: action.payload,
      };
    case UPDATE_COMPANYLOGO_FAILED:
      return { ...state, loading: false };
    case GET_COMPANY_POST_FEED_INIT:
      return { ...state, postFeedLoading: true, };
    case GET_COMPANY_POST_FEED_SUCCESS:
      return { ...state, postFeedLoading: false, getCompanyPostFeed: action.payload };
    case GET_COMPANY_POST_FEED_FAILED:
      return { ...state, postFeedLoading: false };

     case UPDATE_ALLOCATOR_STRATEGY_INIT:
      return { ...state, allocatorInfoLoading: true, allocatorStratgy : [] };
    case UPDATE_ALLOCATOR_STRATEGY_SUCCESS:
      return { ...state, allocatorInfoLoading: false, allocatorStratgy: action.payload };
    case UPDATE_ALLOCATOR_STRATEGY_FAILED:
      return { ...state, allocatorInfoLoading: false };
    case GET_COMPANY_USERS_INIT:
      return { ...state, loading: true, };
    case GET_COMPANY_USERS_SUCCESS:
      return { ...state, loading: false, getCompanyUsers: action.payload };
    case GET_COMPANY_USERS_FAILED:
      return { ...state, loading: false };
    case GET_FUND_SPOTLIGHTS_INIT:
      return { ...state, fundSpotloading: true, };
    case GET_FUND_SPOTLIGHTS_SUCCESS:
      return { ...state, fundSpotloading: false, spotlightFunds: action.payload };
    case GET_FUND_SPOTLIGHTS_FAILED:
      return { ...state, fundSpotloading: false };

    case GET_ALLOCATOR_INFO_INIT:
      return { ...state, loading: true };
    case GET_ALLOCATOR_INFO_SUCCESS:
      return { ...state, loading: false, allocatorInfo: action.payload };
    case GET_ALLOCATOR_INFO_FAILED:
      return { ...state, loading: false };

    case CREATE_ALLOCATOR_INFO_INIT:
      return { ...state, allocatorInfoLoading: true, allocatorInfo : {} };
    case CREATE_ALLOCATOR_INFO_SUCCESS:
      return { ...state, allocatorInfoLoading: false, allocatorInfo: action.payload };
    case CREATE_ALLOCATOR_INFO_FAILED:
      return { ...state, allocatorInfoLoading: false };
    case UPDATE_ALLOCATOR_INFO_INIT:
      return { ...state, allocatorInfoLoading: true };
    case UPDATE_ALLOCATOR_INFO_SUCCESS:
      let allocator = state.allocatorInfo;
      allocator = {
        ...allocator,
        id : action.payload?.id,
        stock: action.payload?.stock,
        governmentBond: action.payload?.governmentBond,
        corporateBond: action.payload?.corporateBond,
        cash: action.payload?.cash,
      }
      return { ...state, allocatorInfoLoading: false, allocatorInfo: allocator };
    case UPDATE_ALLOCATOR_INFO_FAILED:
      return { ...state, allocatorInfoLoading: false };
    
    case UPDATE_FSI_INIT:
      return { ...state, allocatorInfoLoading: true};
    case UPDATE_FSI_SUCCESS:
      let allocatorFsi = state.allocatorInfo;
      allocatorFsi = {
        ...allocatorFsi,
        id : action.payload?.id,
        fsi : action.payload?.fsi
      };
      return { ...state, allocatorInfoLoading: false, allocatorInfo: allocatorFsi };
    case UPDATE_FSI_FAILED:
      return { ...state, allocatorInfoLoading: false };
    case UPDATE_NDE_INIT:
      return { ...state, allocatorInfoLoading: true };
    case UPDATE_NDE_SUCCESS:
      let allocatorNde = state.allocatorInfo;
      allocatorNde = {
        ...allocatorNde,
         id : action.payload?.id,
         nde : action.payload?.nde
      }
      return { ...state, allocatorInfoLoading: false, allocatorInfo: allocatorNde };
    case UPDATE_NDE_FAILED:
      return { ...state, allocatorInfoLoading: false };
    case UPDATE_IDP_INIT:
      return { ...state, allocatorInfoLoading: true};
    case UPDATE_IDP_SUCCESS:
      let allocatorIdp = state.allocatorInfo;
      allocatorIdp = {
        ...allocatorIdp,
         id : action.payload?.id,
         idp : action.payload?.idp
      }
      return { ...state, allocatorInfoLoading: false, allocatorInfo: allocatorIdp };
    case UPDATE_IDP_FAILED:
      return { ...state, allocatorInfoLoading: false };
    case UPDATE_IC_INIT:
      return { ...state, allocatorInfoLoading: true };
    case UPDATE_IC_SUCCESS:
      const investorType = state.getAllInvestors;
      const profile = state.profileDetails;
      const type = investorType?.find(x=>x.id === action.payload);
      const detail = {...profile, investorTypeId : type.id, investorTypeName : type.name}
      return { ...state, allocatorInfoLoading: false, profileDetails : detail };
    case UPDATE_IC_FAILED:
      return { ...state, allocatorInfoLoading: false };
    default:
      return state;
  }
}
